import {
  CreateDialogButton,
  CreateDialogButtonProps,
} from '@/components/refinedev/dialogs/create-dialog-button';
import ProjectContractForm, {ProjectContractForm_GeneralInfo} from '../project_contract-form';
import {BaseKey} from '@refinedev/core';

export const CreateProjectContractDialogButton = ({
  onSuccess,
  project_id,
  canParams,
}: Pick<CreateDialogButtonProps, 'onSuccess' | 'canParams'> & {project_id: BaseKey}) => {
  return (
    <CreateDialogButton
      resource={'project_contracts'}
      title="Tạo hợp đồng dự án"
      canParams={canParams}
      transformBeforeSave={data => ({
        ...ProjectContractForm.transformBeforeSave(data),
        project_id,
      })}
      onSuccess={onSuccess}>
      <div className="flex flex-col gap-4">
        <ProjectContractForm_GeneralInfo />
      </div>
    </CreateDialogButton>
  );
};
